import type { CompositePrimaryKey, GlobalCollectionId, ResolvedMonospacePrimitiveField } from '#layers/data-model/public';
import { useOverlay } from '@nuxt/ui/composables';
import { defineAsyncComponent } from 'vue';

const CollectionListingDrawer = defineAsyncComponent(() => import('#layers/listing/components/Collection/CollectionListingDrawer.vue'));

export function useCollectionItemPicker() {
	const overlay = useOverlay();

	return async function openCollectionItemPicker(
		collectionId: GlobalCollectionId,
		options: { selection: CompositePrimaryKey[]; selectionKeys: ResolvedMonospacePrimitiveField[] },
	): Promise<CompositePrimaryKey[] | null> {
		const modal = overlay.create(CollectionListingDrawer, {
			props: {
				collectionId,
				selectionMode: 'multiple',
				selection: options.selection,
				selectionKeys: options.selectionKeys,
			},
		});

		const result = await modal.open().result;

		return result?.selection ?? null;
	};
}
